// extracted by mini-css-extract-plugin
export default {"popper_header":"Header_popper_header__uDrmw","popper_header__title":"Header_popper_header__title__t6TfI"};